'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dataObject = require('./data-object');

var _dataObject2 = _interopRequireDefault(_dataObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Page = function (_DataObject) {
    (0, _inherits3.default)(Page, _DataObject);
    (0, _createClass3.default)(Page, null, [{
        key: 'PATH',
        get: function get() {
            return 'path';
        } // Relative url to domain (ie. '/cart')

    }, {
        key: 'LOCATION',
        get: function get() {
            return 'location';
        } // Url with protocol, parameter, and hash (ie. 'https://www.example.com/cart?coupon=yay')

    }, {
        key: 'TITLE',
        get: function get() {
            return 'title';
        }
    }, {
        key: 'TEMPLATENAME',
        get: function get() {
            return 'templateName';
        } // Template name

    }, {
        key: 'STATUS',
        get: function get() {
            return 'status';
        } // set if from offline mode 'offline_success', 'offline_failed'

    }]);

    function Page(fields, additionalRequiredFields, keyMap) {
        var _ret;

        var keepExtraFields = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
        (0, _classCallCheck3.default)(this, Page);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Page.__proto__ || (0, _getPrototypeOf2.default)(Page)).call(this, [], [Page.PATH, Page.LOCATION, Page.TITLE, Page.TEMPLATENAME, Page.STATUS], fields, keepExtraFields));

        _this.isValid(additionalRequiredFields, keyMap);

        return _ret = _this.build(keyMap), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    return Page;
}(_dataObject2.default); /* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */
/* Copyright (c) 2017 Mobify Research & Development Inc. All rights reserved. */
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */

exports.default = Page;


//////////////////
// WEBPACK FOOTER
// ./~/progressive-web-sdk/dist/analytics/data-objects/page.js
// module id = 128
// module chunks = 0